import {firebaseAuth, firebaseDatabase, firebaseStorage} from '../../firebase';
import moment from "moment/moment";
import {APPACUTIS_INVOICES, APPACUTIS_OPEN_INVOICE, APPACUTIS_TRANSACTIONS, Client, USERS} from "../utils/Client";
import {
	getOpenInvoiceCreator,
	loading,
	saveInvoices,
	updateStorageLink,
	error,
	success,
	removeInvoice,
	CLEAR, LOADING, getTransactionsCreator
} from "./usersActionsCreator";
import {list as getProducts} from "../../redux/products/productsActions";
import {list as getUsers} from "../../redux/users/userActions";
import {list as getCards, listDioceses} from "../../redux/cards/cardsActions";
import {list as getShops, getShopCategories} from "../../redux/shops/shopsActions";
import {isAdminUser} from "./userTypes";

export const LOGIN = "LOGIN";
export const LOGIN_CHECKING = "LOGIN_CHECKING";
export const LOGIN_DENIED = "LOGIN_DENIED";
export const CLEAR_LOGIN_ERROR = "CLEAR_LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const GET_USERS = "GET_USERS";
export const SAVE = "SAVE";
export const UPDATE_PROFILE_DATA = "UPDATE PROFILE DATA";

let client = new Client();

const LOGIN_DENIED_MESSAGE = "Accesso negato: il gestionale è riservato agli utenti admin.";
const LOGIN_VERIFICATION_ERROR = "Impossibile verificare l'autorizzazione dell'account. Accesso negato.";

function denyLogin(dispatch, message) {
	dispatch({
		type: LOGIN_DENIED,
		payload: message
	});

	return firebaseAuth.signOut().catch(error => {
		console.error("Unable to sign out unauthorized user", error);
	});
}

export function login() {
	return dispatch => {
		let isMounted = true;
		let authCheck = 0;

		const isCurrentUser = (user, check) =>
			isMounted &&
			authCheck === check &&
			firebaseAuth.currentUser &&
			firebaseAuth.currentUser.uid === user.uid;

		const unsubscribe = firebaseAuth.onAuthStateChanged(user => {
			const check = ++authCheck;
			console.log("onAuthStateChanged:", user);
			if (user) {
				dispatch({type: LOGIN_CHECKING});

				firebaseDatabase.ref("users/" + user.uid).once("value")
					.then(snapshot => {
						if (!isCurrentUser(user, check)) return;

						const profile = snapshot.val();
						if (!isAdminUser(profile)) {
							return denyLogin(dispatch, LOGIN_DENIED_MESSAGE);
						}

						dispatch({
							type: LOGIN,
							payload: profile
						});
						dispatch(listDioceses());
						dispatch(getProducts());
						dispatch(getUsers());
						dispatch(getCards());
						dispatch(getShops());
						dispatch(getShopCategories());
					})
					.catch(error => {
						if (!isCurrentUser(user, check)) return;

						console.error("Unable to verify admin access", error);
						return denyLogin(dispatch, LOGIN_VERIFICATION_ERROR);
					});
			} else {
				dispatch(logout());
			}
		}, error => {
			++authCheck;
			console.error("Firebase auth state listener failed", error);
			return denyLogin(dispatch, LOGIN_VERIFICATION_ERROR);
		});

		return () => {
			isMounted = false;
			++authCheck;
			unsubscribe();
		};
	};
}

export function clearLoginError() {
	return {type: CLEAR_LOGIN_ERROR};
}

export function logout() {
	firebaseDatabase.ref("users").off();
	firebaseDatabase.ref("cards").off();
	firebaseDatabase.ref("diocese").off();
	firebaseDatabase.ref("generic_product").off();
	firebaseDatabase.ref("product_category").off();
	firebaseDatabase.ref("shops").off();
	firebaseDatabase.ref("shops_category").off();
	firebaseAuth.signOut();
	return {
		type: LOGOUT
	};
}

export function list() {
	return dispatch => {
		dispatch({
			type: LOADING,
			data: true
		});
		let userRef = firebaseDatabase.ref("users");
		userRef.on("value", data => {
			let userArray = [];
			data.forEach((childSnapshot) => {
				let item = childSnapshot.val();
				userArray.push(item);
			});
			dispatch({
				type: GET_USERS,
				data: userArray
			});
		}, err => {
			console.log(err);
		});
	};
}

export function setUserEnabled(uid, enabled) {
	return () => client.update({enabled}, `${USERS}/${uid}`);
}

export function updateUser(user) {
	return () => client.update(user, `${USERS}/${user.uid}`);
}

export function getInvoices() {
	return dispatch => {
		client.get(APPACUTIS_INVOICES)
			.then(response => {
				response.data.forEach(i => {
					i.invoiceDate = i.invoiceDate && moment(i.invoiceDate).format("DD/MM/YYYY");
					if (i.link) firebaseStorage.refFromURL(i.link).getDownloadURL()
						.then(url => dispatch(updateStorageLink(i.invoiceNumber, "link", url)))
						.catch(e => dispatch(removeInvoice(i.invoiceNumber)));
					if (i.eInvoiceLink) firebaseStorage.refFromURL(i.eInvoiceLink).getDownloadURL()
						.then(url => dispatch(updateStorageLink(i.invoiceNumber, "eInvoiceLink", url)))
						.catch(e => dispatch(removeInvoice(i.invoiceNumber)));
				});
				dispatch(saveInvoices(response.data));
			})
			.catch(e => manageError(e, dispatch));
	};
}

export function getOpenInvoice() {
	return dispatch => {
		client.get(APPACUTIS_OPEN_INVOICE)
			.then(response => {
				let i = response.data;
				i.startDate = i.startDate && moment(i.startDate).format("DD/MM/YYYY");
				dispatch(getOpenInvoiceCreator(i));
			})
			.catch(e => manageError(e, dispatch));
	};
}

export function closeInvoice(invoiceId) {
	return dispatch => {
		dispatch(loading());
		client.save(null, `${APPACUTIS_OPEN_INVOICE}/${invoiceId}/close`)
			.then(() => {
				dispatch(getInvoices());
				dispatch(getOpenInvoice());
				dispatch(success());
			})
			.catch(e => manageError(e, dispatch));
	};
}

export function updateProfile(profile = {}) {
	const UID = firebaseAuth.currentUser.uid;
	if (!UID) return false;

	// Set the email against user account
	return () =>
		firebaseAuth
			.currentUser.updateEmail(profile.email)
			.then(() => {
				// Then update user in DB
				firebaseDatabase
					.ref()
					.child(`users/${UID}`)
					.update(profile);
			});
}

export function updatePassword(oldPassword, newPassword) {
	return () => {
		let user = firebaseAuth.currentUser;
		let cred = firebaseAuth.EmailAuthProvider.credential(user.email, oldPassword);
		user.reauthenticateAndRetrieveDataWithCredential(cred)
			.then(() => user.updatePassword(newPassword))
			.catch((error) => console.log(error));
	};
}

export function updateDioceses(dioceses) {
	let updates = {};
	updates[`/diocese`] = dioceses;
	return () => firebaseDatabase.ref().update(updates);
}

export function getTransactions() {
	return dispatch => {
		client.get(APPACUTIS_TRANSACTIONS)
			.then(response => {
				dispatch(getTransactionsCreator(response.data));
			})
			.catch(e => manageError(e, dispatch));
	};
}

function manageError(e, dispatch) {
	dispatch(loading(false));
	if (e.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		dispatch(error(e.response.data.message));
	} else {
		// Something happened in setting up the request that triggered an Error
		console.log('Error', e.message);
		dispatch(error(e.message));
	}
}

export function clear() {
	return {
		type: CLEAR
	};
}
